export const AXIOS_DEFAULT_OPTIONS = { credentials: 'include' };
export const AXIOS_DEFAULT_OPTIONS_HEADERS = { credentials: 'include', headers: { 'Content-Type':'application/json;charset=utf-8' } };

export default {};
